<template>
  <div>
    <div id="overlay" v-if="fetchingData">
      <div class="spinner"></div>
    </div>
    <h1>
      Thank you!
    </h1>
    <table class="table">
      <thead>
        <tr>
          <th scope="col">Order Summary</th>
          <th scope="col">Amount</th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td>Site Balance</td>
          <td>${{paymentTotal}}</td>
        </tr>
        <tr>
          <td>Total:</td>
          <td>${{paymentTotal}}</td>
        </tr>
      </tbody>
    </table>
    <dl class="row" v-if="paymentGateway === 'Paymentus'">
      <dt class="col-sm-3">{{paymentGateway}} Confirmation Number:</dt>
      <dd class="col-sm-9">{{confirmationNumber}}</dd>
    </dl>
    <p>
      Thank you for using the Cook County Department of Environment &amp; Sustainability on-line permit application
      system.
    </p>
    <dl class="row">
      <dt class="col-12">For Customer Service:</dt>
      <dt class="col-sm-3">Hours:</dt>
      <dd class="col-sm-9">8:30am - 4:30pm</dd>
      <dt class="col-sm-12">Email: certificateofoperations@cookcountyil.gov</dt>
    </dl>
  </div>
</template>
<script>
import { confirmTransaction } from '@/js/FormFunctions';

export default {
  name: 'InvoiceThankYou',
  props: ['gatewayKey'],
  data() {
    return {
      siteNumber: '',
      isValidNum: false,
      fetchingData: true,
      erroMessage: '',
      paymentTotal: 0,
      confirmationNumber: null,
      paymentGateway: null,
    };
  },
  beforeMount() {
    this.fetchingData = true;
    this.confirmationNumber = this.$route.query.confirmationNumber;
    confirmTransaction(this.gatewayKey, this.confirmationNumber)
      .then((res) => {
        this.paymentTotal = res[0].amount;
        this.paymentGateway = res[0].paymentGateway;
        this.fetchingData = false;
        // this.submitRequest()
      });
  },
};

</script>
